import formatTime from './formatTime';


export default {
    install(Vue) {
        Vue.filter("formatTime", formatTime);
    }
}